<template>
  <div class="language-selector">
    <v-select dense outlined v-model="language" :items="languages" item-text="slug" item-value="slug" :label="label" @change="changeLanguage()">
    </v-select>
  </div>
</template>

<script>
import SharedFunctionsMixin from '../../mixins/SharedFunctions.vue';

export default {
  mixins: [SharedFunctionsMixin],
  data() {
    return {
      language: null,
    };
  },
  computed: {
    languages() {
      return this.$store.state.config.languages;
    },
    selectedLanguage() {
      return this.$store.state.config.selectedLanguage;
    },
    label() {
      let lang = this.$store.state.config.selectedLanguage;
      if (lang == null) lang = this.$store.state.config.defaultLanguage;
      return this.$store.getters.content.language_label[lang];
    },
  },
  methods: {
    changeLanguage() {
      const lang = this.language;
      if (lang != null || lang != undefined) {
        localStorage.setItem('language', lang);
        this.$store.commit('SET_SELECTED_LANGUAGE', lang);
        this.$store.commit('SET_INTAKE_FORM_DATA_ITEM', { key: 'language', value: lang });
      }
    },
  },
};
</script>
<style lang="scss">
.v-select__selection,
.v-list-item__title {
  text-transform: capitalize;
}
.language-selector {
  margin: 25px 10px 0 0;
  max-width: 180px;
}
</style>
